export const ONBOARDING_STORAGE_KEY = "mobile-onboarding-completed"
